import { UserModel } from './../models/user.model';
import { StorageService } from './storage.service';
import { AlertService } from './alert.service';
import { MissionService } from './mission.services';
import { Injectable } from '@angular/core';
import { AppConfig } from '../app/app.config';
import { AuthService } from './auth.service';
import * as baseConfig from "./../assets/config/config.json";
import * as $ from 'jquery';
import 'signalr';
import layer from 'layui-layer';
import { setTimeout } from 'timers';

@Injectable()
export class SignalrService {

    AppConfig = AppConfig;
    public connected: boolean = false;

    public static connectTimes: number = 0;
    private timer: any;

    constructor(
        private mission: MissionService,
        private auth: AuthService,
        private alert: AlertService,
        private storage: StorageService
    ) { }

    init(signalrUrl) {
        let url = signalrUrl ? signalrUrl : baseConfig.signalrLink;
        if (this.connected) {
            return;
        }
        AppConfig.connection = $.hubConnection(url, { qs: 'Authorization=' + this.auth.getToken() });
        let hubProxy = AppConfig.connection.createHubProxy('legendHub');
        hubProxy.on('getNotification', d => {
            this.mission.announceMission(d);
            this.getEvents(d);
        });

        this.connect();

        AppConfig.connection.error((err) => {
            this.stop();
            // console.log('AppConfig.connection', err);
            let connectTimer = setTimeout(() => {
                this.connect();
                clearTimeout(connectTimer);
            }, 5000);
        })

    }

    connect() {
        AppConfig.connection.start().done(() => {
            this.connected = true;
            console.log('signalr connected');
        }).fail(() => {
            console.log('signalr connect failed');
        });
    }

    stop() {
        AppConfig.connection.stop();
    }

    // 监听事件
    // TQQ 2017-05-11
    getEvents(d) {
        switch (d['Type']) {
            case 'Kickout':
                layer.alert('网络延迟', {
                    icon: 1,
                    title: '提示',
                    time: 3000,
                    yes: s => {
                        layer.close(s);
                    },
                    end: e => {
                        this.auth.logout();
                    }
                });
                break;
            case 'ResetLoginPwd':
                layer.alert('已重置登录密码', {
                    icon: 1,
                    title: '提示',
                    time: 3000,
                    yes: s => {
                        layer.close(s);
                    },
                    end: e => {
                        this.auth.logout();
                    }
                });
                break;
            case 'UserCapital': //用户信息
            case 'UserExpand':
            case 'UserInfo':
                let user = this.storage.read<UserModel>("User");
                $.extend(user, d['Data']);
                this.storage.write("User", user);
                AppConfig.User = user;
                break;
            case 'UserMessage':
                this.onUserMessage(d['Data']);
                break;
            case 'UserNotice':
                this.onUserNotice(d['Data']);
                break;
            case "Announcement":
            case "Release"://公告推送
                layer.open({
                    title: d['Data'].Title,
                    anim: 2,
                    type: 1,
                    skin: 'GongGao',
                    area: ['800px', '670px'],
                    content: d['Data'].Summary,
                    icon: 7
                });
                break;
            case 'OtherPlaceLogin'://被迫下线
                layer.alert('该帐户已在其它地方登录，您将退出。如果不是本人操作，您的密码可能已泄露，请尽快修改密码。', {
                    icon: 1,
                    title: '提示',
                    time: 3000,
                    yes: s => {
                        layer.close(s);
                    },
                    end: e => {
                        this.storage.clear();
                        this.auth.logout();
                    }
                });
                break;
        }
    }
    //消息提醒
    //TQQ 2017-05-11
    onUserMessage(msg) {
        let title = "", content = "";
        if (msg.TypeCode == '01') {
            title = '上级发来的消息';
            content = msg.Contect;
        } else if (msg.TypeCode == '02') {
            title = '下级发来的消息';
            content = msg.Contect + '-' + msg.sendUserName;
        } else {
            title = '系统发来的消息';
            content = msg.Contect;
        }
        // layer.msg(content);
        this.alert.WarnInfor(content, title);
    }

    //通知消息
    //TQQ 2017-05-11
    onUserNotice(notice) {
        if (notice.Title) {
            if (notice.Title.indexOf('中奖消息') >= 0 && AppConfig.winPlayVoice) {
                var audio = document.createElement("audio");
                audio.src = "./../assets/mp3/winning.mp3";
                audio.play();
            }
            let content = notice.Contect;
            this.alert.WarnInfor(content, notice.Title);
        }
    }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-3!./node_modules/angular2-template-loader!./node_modules/tslint-loader??ref--7-0!./src/providers/signalr.service.ts